var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeathers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 97,
    viewBox: "0 0 156 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9507_62400)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip1_9507_62400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.634 34.8278C138.957 31.9354 135.816 29.6221 132.395 27.9282C132.394 27.9308 132.392 27.9334 132.391 27.936C135.244 23.3801 138.039 19.5657 140.352 16.9398C142.416 14.5959 144.782 12.2096 141.741 17.2603C139.937 20.2577 138.298 25.9847 141.634 34.8278Z",
    fill: "#6160A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.396 27.9283C130.952 30.2343 129.491 32.7303 128.071 35.3585C131.998 37.1895 135.447 40.1069 137.92 43.9853C137.68 43.5895 137.42 43.1954 137.141 42.8032C141.408 46.6777 141.905 49.7591 142.274 52.0446C142.321 52.3353 142.366 52.6131 142.416 52.878C144.722 45.8605 144.512 42.2877 141.736 35.0927C141.702 35.0041 141.668 34.9159 141.635 34.8279C138.958 31.9355 135.817 29.6222 132.396 27.9283Z",
    fill: "#90DF9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.075 35.3475C121.022 48.3921 114.94 64.6929 116.529 77.153C118.51 77.4273 123.05 76.4596 126.709 73.2449C132.986 67.7302 133.921 59.6002 129.826 53.0214C131.035 53.7706 135.026 56.9995 135.684 63.2011C140.668 57.633 142.098 50.1184 137.411 43.1937C134.983 39.702 131.736 37.0528 128.075 35.3475Z",
    fill: "#8E8CEE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip2_9507_62400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1488 62.1057C90.9129 63.1991 93.3964 64.7767 95.5206 66.7193C95.5192 66.7211 95.5179 66.7229 95.5166 66.7247C97.9412 63.4752 99.8608 60.4697 101.076 58.127C102.161 56.036 103.193 53.7216 100.472 57.2375C98.8564 59.3241 95.2767 62.0389 88.1488 62.1057Z",
    fill: "#6160A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5204 66.7189C94.2932 68.364 92.9365 70.0716 91.4761 71.7875C89.1173 69.5257 86.1249 67.8962 82.7233 67.216C83.0671 67.2768 83.4151 67.3518 83.7671 67.4413C79.8785 65.4977 77.5764 65.9888 75.8687 66.3531C75.6516 66.3995 75.444 66.4437 75.244 66.4807C79.549 62.9445 82.1185 62.1176 87.9348 62.1064C88.0064 62.1063 88.0776 62.1059 88.1485 62.1052C90.9127 63.1986 93.3962 64.7762 95.5204 66.7189Z",
    fill: "#90DF9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4825 71.7808C84.2347 80.2986 74.4326 89.0222 65.238 91.3043C64.5047 89.9863 63.9465 86.5301 65.2086 83.0803C67.3736 77.1623 72.8349 74.287 78.578 75.3717C77.7212 74.7256 74.3622 72.8007 69.8221 74.0299C72.3775 69.0065 77.2709 65.9508 83.4186 67.3574C86.536 68.1115 89.2846 69.6716 91.4825 71.7808Z",
    fill: "#8E8CEE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip3_9507_62400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3545 25.661C77.7233 30.2468 77.2278 34.7736 75.9799 39.0505C75.9764 39.0498 75.9729 39.0492 75.9694 39.0486C82.1387 40.1974 87.6241 40.8114 91.7078 40.8999C95.3529 40.9787 99.2726 40.8325 92.5307 39.4529C88.5295 38.6342 82.3145 35.5159 77.3545 25.661Z",
    fill: "#6160A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9797 39.0501C72.8569 38.4688 69.5586 37.7504 66.1781 36.8937C67.709 32.0728 67.929 26.8037 66.5511 21.6145C66.7014 22.1337 66.8349 22.6683 66.9509 23.2184C66.9954 16.4901 64.7412 13.6278 63.0692 11.5047C62.8565 11.2347 62.6533 10.9767 62.4654 10.7242C70.3166 14.2891 73.2197 17.2933 77.2067 25.3643C77.2558 25.4637 77.305 25.5624 77.3543 25.6604C77.7231 30.2463 77.2277 34.7731 75.9797 39.0501Z",
    fill: "#90DF9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1914 36.8975C49.4115 32.6468 30.6015 24.9885 21.1535 13.7758C22.4834 11.8573 26.9028 8.722 32.5562 8.11939C42.2545 7.08559 49.9773 12.7079 52.3922 21.4255C52.7046 19.7943 53.0847 13.8143 48.2772 8.34765C56.9995 8.46685 64.5852 13.1771 66.8292 22.6766C67.9103 27.5216 67.6203 32.4044 66.1914 36.8975Z",
    fill: "#8E8CEE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip4_9507_62400)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4442 64.3142C13.5806 61.2027 15.2648 58.3896 17.3663 55.966C17.3684 55.9675 17.3706 55.969 17.3727 55.9705C13.6811 53.3652 10.2762 51.3154 7.63056 50.0306C5.26911 48.8839 2.66041 47.8019 6.65743 50.7302C9.02954 52.468 12.1594 56.3757 12.4442 64.3142Z",
    fill: "#6160A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3671 55.9659C19.2359 57.2845 21.1782 58.7455 23.1328 60.3216C20.6828 63.0162 18.9557 66.3979 18.2983 70.2074C18.356 69.8225 18.4292 69.4325 18.5186 69.0377C16.468 73.427 17.0831 75.9771 17.5393 77.8686C17.5974 78.1092 17.6528 78.3391 17.6999 78.5608C13.6336 73.8693 12.6366 71.0313 12.4526 64.5523C12.4503 64.4726 12.4477 64.3932 12.4449 64.3143C13.5814 61.2027 15.2656 58.3895 17.3671 55.9659Z",
    fill: "#90DF9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.124 60.3153C32.8267 68.138 42.834 78.8003 45.6474 88.9757C44.2008 89.8315 40.3671 90.5553 36.4868 89.2511C29.8303 87.0138 26.4661 81.0147 27.505 74.585C26.8105 75.5585 24.7652 79.3572 26.2685 84.3786C20.5971 81.6801 17.0486 76.319 18.4342 69.429C19.1824 65.9339 20.8392 62.826 23.124 60.3153Z",
    fill: "#8E8CEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9507_62400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 96,
    fill: "white",
    transform: "translate(0.5 0.730469)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9507_62400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.8274,
    height: 54.8274,
    fill: "white",
    transform: "matrix(0.506951 0.861975 0.861975 -0.506951 92.8281 36.854)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9507_62400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.3507,
    height: 41.3507,
    fill: "white",
    transform: "translate(100.039 96.9746) rotate(-170.746)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_9507_62400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(37.041 65.9858) rotate(-106.925)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_9507_62400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.0809,
    height: 46.0809,
    fill: "white",
    transform: "translate(50.9375 50.0396) rotate(97.737)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeathers);
export default __webpack_public_path__ + "static/media/feathers.6e1cf67ae8e50ab404a6f539da760079.svg";
export { ForwardRef as ReactComponent };